class StLocationController {
    constructor($translate, locationsService, DATE_FORMAT) {
        'ngInject';
        this.name = 'stLocation';
        this.$translate = $translate;
        this.TYPE_AIRPORT = 'airport';
        this.TYPE_HOTEL = 'hotel';
        this.TYPE_SEAPORT = 'sea_port';
        this.TYPE_TRAINSTATION = 'train_station';
        this.TYPE_ACCOMODATION = 'accommodation';
        this.DATE_FORMAT = DATE_FORMAT;
        this.locationsService = locationsService
        this.hotels = [];
    }

    $onInit() {
        this.transferData = this.transfer[this.direction].data;
        this.type = this.transfer[this.direction].type;

        if (this.type == this.TYPE_ACCOMODATION) {
            if (this.transferData.address1) {
                let address2 = "";
                let address3 = "";

                if (this.transferData.address2) {
                    address2 = "\n" + this.transferData.address2;
                    this.transferData.address2 = '';
                }
                if (this.transferData.address3) {
                    address3 = "\n" + this.transferData.address3;
                    this.transferData.address3 = '';
                }

                this.transferData.address1 = this.transferData.address1.concat(
                    address2,
                    address3
                );
            }
        }

        this.transferData.airline = (this.transferData.airline === 'NOT_PROVIDED' && this.isDirectionFrom() ? '' : this.transferData.airline);
        this.transferData.origin_airport = (this.transferData.origin_airport === 'NOT_PROVIDED' ? '' : this.transferData.origin_airport);
        this.transferData.flight_number = (this.transferData.flight_number === 'NOT_PROVIDED' ? '' : this.transferData.flight_number);

        //airport && from
        this.isFromAndAirport = this.type == this.TYPE_AIRPORT && this.isDirectionFrom();

        this.translations = this.$translate.instant([
            "outward_airline",
            "flight_num",
            "flight_origin",
            "yes",
            "no",
            "inform_later",
            "arr_date",
            "flight_dept",
            "ship_arrival_date",
            "ship_departure_time",
            "gateway_cruiseline",
            "gateway_cruise_terminal",
            "gateway_ship_name",
            "gateway_train",
            "train_arrival_date",
            "train_departure_date",
            "out_accom",
            "outward_acc",
            "outward_acc3",
            "trans_from",
            "trans_to",
            "hotel_pickup",
            "hotel_dest",
            "departure_pickup",
            "your_pickup_time",
            "pickup_date",
            "share_email_from",
            "share_email_to:",
            "departure_pickup",
            "hotel_placeholder"
        ]);

        this.translations["transfer_sub_title"] = this.isDirectionFrom() ? this.translations.trans_from : this.translations.trans_to;
        this.translations["hotel_title"] = this.isDirectionFrom() ? this.translations.hotel_pickup : this.translations.hotel_dest;
        this.translations['transfer_label'] = this.isDirectionFrom() ? this.translations.share_email_from : this.translations['share_email_to:'];
        this.translations['fligth_datetime_label'] = this.isDirectionFrom() ? this.translations.arr_date : this.translations.flight_dept;
        this.translations['train_datetime_label'] = this.isDirectionFrom() ? this.translations.train_arrival_date : this.translations.train_departure_date;
        this.translations['ship_datetime_label'] = this.isDirectionFrom() ? this.translations.ship_arrival_date : this.translations.ship_dept;

        this.getHotels();
    }

    //TODO: Improve
    isDirectionFrom() {
        return this.direction == "from";
    }

    isDirectionTo() {
        return !this.isDirectionFrom();
    }

    getHotels() {
        if (this.type !== this.TYPE_HOTEL) {
            return;
        }
        this.hotel = this.transferData.name;
        this.locationsService.getHotels(this.transferData.location_id).then((response) => {
            this.hotels = response;
        });
    }

    onSelectHotel($item, $model, $label, $event) {
        this.transferData.id = $item.id;
        this.transferData.name = $item.name;
    }

    onBlurHotel() {
        if (angular.isString(this.hotel) && this.hotel != this.transferData.name) {
            this.hotel = this.transferData.name;
        }
    }
}

export default StLocationController;


// WEBPACK FOOTER //
// ./client/app/common/stLocation/stLocation.controller.js